module.exports={
    "data":{
    "GetAllShoeboxItemsResponseMessage": {
        "baseMessage": {
            "uuid": "B4CC9B36AA8F4E5BB5C48FC997F54A75",
            "exchangeType": "SENDREPLY",
            "headerVersion": "1.0",
            "returnCode": "200",
            "returnCodeDescription": "OK",
            "processTimings": {
                "timings": [
                    {
                        "processid": "DataPower",
                        "duration": "846"
                    }
                ]
            },
            "statusMsgs": {
                "messages": [
                    {
                        "values": []
                    }
                ]
            },
            "username": "NONE"
        },

            "payload": {
                "returnCode": "0",
                "errorText": "",
                "paginationResult": "",
                "totalShoeboxItems": "",
                "totalShoeboxItemsInResponse": "",
                "shoeboxItems": [
                    {
                        "ID": "111111",
                        "category": "Medical-Preventative",
                        "amount": "145.64",
                        "serviceDate": "08/26/2015",
                        "provider": "Random Doctor",
                        "status": "",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "alpha.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Dental",
                        "amount": "77.25",
                        "serviceDate": "08/26/2015",
                        "provider": "Respected Doctor",
                        "status": "Used",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "beta.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Cash",
                        "amount": "23.44",
                        "serviceDate": "08/26/2015",
                        "provider": "Expensive Doctor",
                        "status": "",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "gamma.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Vision",
                        "amount": "456.78",
                        "serviceDate": "08/26/2015",
                        "provider": "Cheapo Doctor",
                        "status": "Used",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "epsilon.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Medical-Preventative",
                        "amount": "124.64",
                        "serviceDate": "08/26/2015",
                        "provider": "Sleepy Doctor",
                        "status": "",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "stigma.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Medical-OTC",
                        "amount": "67.01",
                        "serviceDate": "08/26/2015",
                        "provider": "Alert Doctor",
                        "status": "Used",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "zeta.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Medical-Preventative",
                        "amount": "33.00",
                        "serviceDate": "08/26/2015",
                        "provider": "Random Doctor",
                        "status": "",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "alpha.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Medical",
                        "amount": "78.39",
                        "serviceDate": "08/26/2015",
                        "provider": "Respected Doctor",
                        "status": "Used",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "beta.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Dental",
                        "amount": "899.27",
                        "serviceDate": "08/26/2015",
                        "provider": "Expensive Doctor",
                        "status": "",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "gamma.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Vision",
                        "amount": "64.25",
                        "serviceDate": "08/26/2015",
                        "provider": "Cheapo Doctor",
                        "status": "Used",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "epsilon.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Medical-OTC",
                        "amount": "1.01",
                        "serviceDate": "08/26/2015",
                        "provider": "Sleepy Doctor",
                        "status": "",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "stigma.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Medical-Preventative",
                        "amount": "9.58",
                        "serviceDate": "08/26/2015",
                        "provider": "Alert Doctor",
                        "status": "Used",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "zeta.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Medical",
                        "amount": "29.99",
                        "serviceDate": "08/26/2015",
                        "provider": "Random Doctor",
                        "status": "",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "alpha.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Dental",
                        "amount": "561.33",
                        "serviceDate": "08/26/2015",
                        "provider": "Respected Doctor",
                        "status": "Used",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "beta.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Vision",
                        "amount": "97.00",
                        "serviceDate": "08/26/2015",
                        "provider": "Expensive Doctor",
                        "status": "",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "gamma.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Medical-OTC",
                        "amount": "4.56",
                        "serviceDate": "08/26/2015",
                        "provider": "Cheapo Doctor",
                        "status": "Used",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "epsilon.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Medical-Preventative",
                        "amount": "67.94",
                        "serviceDate": "08/26/2015",
                        "provider": "Sleepy Doctor",
                        "status": "",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "stigma.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Medical",
                        "amount": "100.00",
                        "serviceDate": "08/26/2015",
                        "provider": "Alert Doctor",
                        "status": "Used",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "zeta.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    },
                    {
                        "ID": "111111",
                        "category": "Dental",
                        "amount": "15.36",
                        "serviceDate": "08/26/2015",
                        "provider": "Inquisitive Doctor",
                        "status": "",
                        "uploadDateTime": "08/31/2015",
                        "note": "This is the best receipt ever created",
                        "patientName": "Sample McSample",
                        "paymentMode": "Debit",
                        "shoeboxImageCount": "3",
                        "shoeboxImages": [
                            {
                                "ID" : "334455",
                                "shoeboxID" : "223311",
                                "name" : "eta.jpg",
                                "size" : "9637",
                                "isThumbnail" : "no"
                            }
                        ]
                    }
                ]
            }

    }
    }
}